<div class="map-container">

  <google-map
    #map
    (tilesloaded)="this.mapInitialized.next(true)"
    *ngIf="apiLoaded | async"
    [zoom]="zoom"
    [center]="center"
    height="400"
    width="100%"
  >
    <listing-map-pin *ngFor="let pin of (pins | async)" [pin]="pin"></listing-map-pin>
  </google-map>

  <div class="map-legend d-flex">
    <div class="icon-container" *ngIf="isComingSoonApplied"><img src="assets/houwzer/pins/coming_soon_pin.png" />Coming Soon!</div>
    <div class="icon-container" *ngIf="isActiveApplied"><img src="assets/houwzer/pins/active_pin.png" />For Sale</div>
    <div class="icon-container" *ngIf="isActiveUnderContractApplied"><img src="assets/houwzer/pins/pending_pin.png" />Pending Sale</div>
    <div class="icon-container" *ngIf="isPendingApplied"><img src="assets/houwzer/pins/pending_pin.png" />Pending Sale</div>
    <div class="icon-container" *ngIf="isSoldApplied"><img src="assets/houwzer/pins/sold_pin.png" />Sold</div>
  </div>
</div>
